namespace GeniuzPOS.Supplier {
    export class CsSupplTypeColumns {
        static columnsKey = 'Supplier.CsSupplType';
    }
}
